import { Component, OnInit } from '@angular/core';
import { MatSnackBarRef } from '@angular/material';

@Component({
  selector: 'app-custom-snackbar',
  templateUrl: './custom-snackbar.component.html',
  styleUrls: ['./custom-snackbar.component.css']
})
export class CustomSnackbarComponent{

  constructor(private snackBarRef: MatSnackBarRef<CustomSnackbarComponent>) { }

  close(): void{
    this.snackBarRef.dismiss();
  }


}
